var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrownFilled = function SvgCrownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25a3 3 0 1 0-4.258 2.714c-.47 1.376-1.536 3.786-3.242 3.786-2.3 0-2.967-3.142-3.53-6.175a3 3 0 1 0-1.94 0c-.56 3.1-1.239 6.175-3.53 6.175-1.706 0-2.772-2.41-3.242-3.786a3.008 3.008 0 1 0-2.129.141l1.635 9.809a1 1 0 0 0 .986.836h14.5a1 1 0 0 0 .986-.836l1.635-9.809A2.99 2.99 0 0 0 24 6.25M19.25 21.25H4.75a1 1 0 0 0 0 2h14.5a1 1 0 0 0 0-2"
  })));
};
export default SvgCrownFilled;